<template>
  <div class="pt-5">
    <default-card>
      <template slot="title-left">
        {{is_component_used_in_all_events ? 'Todos Eventos' : 'Próximos Eventos'}} 🚀
      </template>
      <template slot="title-right">
        <v-btn
          v-if="is_component_used_in_all_events"
          icon
          color="primary"
          @click="$emit('changeCalendar')"
        >
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
      </template>
      <template slot="content">
        <card-loading-transparent v-if="loading"/>
        <div v-if="!loading" style="width: 100%" class="d-inline-flex justify-center my-2">
          <div class="d-inline-flex date-picker-all-events">
            <calendar-date-picker v-if="is_component_used_in_all_events" @datePicked="setStartDate" class="mt-2" :date="start_date" is_date_type_month is_component_show_event is_component_used_in_all_events label="De: "/>
          
            <calendar-date-picker v-if="is_component_used_in_all_events" @datePicked="setEndDate" class="mt-2" :date="end_date" is_date_type_month is_component_show_event is_component_used_in_all_events label="Ate: "/>
          </div>
        </div>
        <v-data-table :mobile-breakpoint="1" :headers="headers" :items="all_events"  item-key="id" v-if="!loading">

          <template v-slot:[`item.name`]="{ item }" >
            <div class="d-flex flex-column py-2" v-if="$vuetify.breakpoint.mobile">
              <div class="font-weight-bold">{{item.name}}</div>
              <div>{{ $dayjs(item.start_at).format('DD/MM/YYYY') }}</div>
            </div>
            <div v-if="!$vuetify.breakpoint.mobile">
              {{ item.name }}
            </div>
          </template>

          <template v-slot:[`item.start_at`]="{ item }">
            {{ !$vuetify.breakpoint.mobile ? $dayjs(item.start_at).add(12,'h').format('l') : $dayjs(item.start_at).add(12,'h').format('DD/MM/YY') }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-chip  dark small :color="item_map[item.category].color || event_status_map[item.status].color"> 
              <v-icon small class="pr-1">{{item_map[item.category].icon}}</v-icon>
              <span class="text-caption">{{item_map[item.category].text || event_status_map[item.status].text}} </span>
            </v-chip>
            <!-- <span style="font-weight: bold; text-transform: uppercase; color: black" v-if="item.category == 'event'">
              {{event_status_map[item.status].text}}
              <v-icon class="mb-1" small :color="event_status_map[item.status].color">mdi-circle</v-icon>
            </span>
            <span style="font-weight: bold; text-transform: uppercase; color: #ff5252" v-if="item.category == 'block_calendar'">
              BLOQUEIO DE AGENDA
              <v-icon class="mb-1" small color="error">mdi-lock</v-icon>
            </span> -->
          </template>

          <template v-slot:[`item.actions`]="{ item }" >
            <div class="d-flex justify-center">
              <v-btn color="normal" small icon @click="showEventOnClick(item.id)"><v-icon small>mdi-pencil</v-icon></v-btn>
              <delete-event :event_id="item.id"></delete-event>
            </div>
          </template>

          <!-- <template v-if="this.$route.name != 'Home'" v-slot:item.id="{ item }">
            <v-btn color="normal" small icon @click="$emit('selectedEvent', item)"><v-icon small>mdi-magnify</v-icon></v-btn>
          </template> -->
        
        </v-data-table>
      </template>
      <template slot="actions"> </template>
    </default-card>
  </div>
</template>

<script>
import Api from '@/api'
import { mapState, mapActions, mapGetters } from 'vuex';
import DeleteEvent from '../DeleteEvent.vue';

export default {
  name: 'NextEvents',
  props: {
    is_component_used_in_all_events: {
      type: Boolean,
      default: ()=> false
    },
  },
  components: {
    CalendarDatePicker: () => import ('../calendar/CalendarDatePicker.vue'),
    DeleteEvent,
  },
  data () {
    return {
      start_date: null,
      end_date: null,
      search: '',
      loading: false,
      //calories: '',
      all_events: [],
      status_color: {
        
      },
      item_map:{
        event:{icon:'mdi-circle', },
        block_calendar:{text: !this.$vuetify.breakpoint.mobile ? 'BLOQUEIO DE AGENDA' : 'BLOQUEIO', icon:'mdi-lock', color:'#ff5252'}
      },
      event_status_map:{
        waiting: { text: 'AGUARDANDO', color: 'amber' },
        open: { text: 'CONFIRMADO', color: 'primary' },
        cancelled: { text: 'CANCELADO', color: 'error' },
        executed: { text: 'EXECUTADO', color: 'success' },
        in_negociation: { text: 'NEGOCIANDO', color: 'primary' },
        canceled_negociation: { text: 'CANCELADA', color: 'error' },
        filed: { text: 'ARQUIVADA', color: 'secondary' },
      },
    }
  },
  computed: {
    headers () {
      return !this.$vuetify.breakpoint.mobile ? [
        {text: 'Nome',value: 'name',align: 'center',},
        {text: 'Data',value: 'start_at',},
        {text: 'Cliente',align: 'center',value: 'client_name',},
        { text: 'Status', value: 'status', align: 'center'},
        { text: 'Ações', value: 'actions', align: 'center', sortable: false},
      ] : [
        {text: 'Evento',value: 'name',align: 'center',},
        { text: 'Status', value: 'status', align: 'center'},
        { text: 'Ações', value: 'actions', align: 'center', sortable: false},
      ]
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId
    }),
  },
  methods: {
    setStartDate(month){
      localStorage.setItem('start_date', this.$dayjs(month).startOf('month').format('YYYY-MM-DD') );
      this.start_date = this.$dayjs(month).startOf('month').format('YYYY-MM-DD')

      if( this.$dayjs(month).isAfter(this.$dayjs(this.end_date)) ){
        this.setEndDate(this.$dayjs(month).add(1, 'month'))
      }
    },
    setEndDate(month){
      localStorage.setItem('end_date', this.$dayjs(month).endOf('month').format('YYYY-MM-DD') );
      this.end_date = this.$dayjs(month).endOf('month').format('YYYY-MM-DD')

      if( this.$dayjs(month).isBefore(this.$dayjs(this.start_date)) ){
        this.setStartDate(month)
      }
    },
    showEventOnClick(event_id){
      let route = this.$router.resolve({name: 'ShowEvent', params: {id: event_id}})
      window.open(route.href, '_blank')
      // this.$router.push({name: 'ShowEvent', params: {id: event_id}})
    },
    setupDate(){
      if(localStorage.getItem('start_date') && localStorage.getItem('end_date')){
        this.start_date = localStorage.getItem('start_date')
        this.end_date = localStorage.getItem('end_date')
      }else{
        let start_month = this.$dayjs().subtract(1, 'month')
        let end_month = this.$dayjs().add(1, 'month')
        this.setStartDate(start_month)
        this.setEndDate(end_month)
      }
    },
    getData(){
      if(this.activeCompanyId){
        this.loading = true
        let filter = {
          company_id: this.activeCompanyId,
          start_date: this.is_component_used_in_all_events ? this.start_date : this.$dayjs().format('YYYY-MM-DD'),
          end_date: this.is_component_used_in_all_events ? this.end_date : this.$dayjs().add(1, 'year').endOf('month').format('YYYY-MM-DD'),
        }
        Api.Event.index(filter).then(r=>r.data).then(d=> {
          this.all_events = d
          if(d[0]){
            this.$emit('selectedEvent', d[0])
          }
        }).catch((err) => {
          console.log(err);
        }).finally(()=>{
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.setupDate()
  },
  watch: {
    start_date(){
      this.getData()
    },
    end_date(){
      this.getData()
    },
    activeCompanyId(){
      this.getData()
    }
  },
}
</script>

<style>
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th{
    padding: 0 5px 0 5px!important;
  }

</style>